<template>
    <transition name="component-fade" mode="out-in">
        <div>
            <Header></Header>
            <slot/>
            <Footer></Footer>
            <Lnb></Lnb>
        </div>
    </transition>
</template>

<script>
import Header from "./Header.vue";
import Footer from "./Footer.vue";
import Lnb from "./Lnb.vue";


export default {
    name: "LayoutStudio",
    components: {
        Header,
        Footer,
        Lnb,
    }
};
</script>

<style scoped lang="scss">

//transition
.component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .3s ease;
}

.component-fade-enter, .component-fade-leave-to
    /* .component-fade-leave-active below version 2.1.8 */
{
    opacity: 0;
}

</style>